import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CustomerDTO } from 'src/app/shared/models/model';
import { authervice } from 'src/app/shared/service/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public loginForm: FormGroup;
  public registerForm: FormGroup;

  Customer:CustomerDTO;

  constructor(private formBuilder: FormBuilder, private authervice:authervice,private router: Router) {
    this.createLoginForm();
    this.createRegisterForm();
  }

  owlcarousel = [
    {
      title: "Welcome to Multikart",
      desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.",
    },
    {
      title: "Welcome to Multikart",
      desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.",
    },
    {
      title: "Welcome to Multikart",
      desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.",
    }
  ]
  owlcarouselOptions = {
    loop: true,
    items: 1,
    dots: true
  };

  createLoginForm() {
    this.loginForm = this.formBuilder.group({
      userName: [''],
      password: [''],
    })
  }
  createRegisterForm() {
    this.registerForm = this.formBuilder.group({
      userName: [''],
      password: [''],
      confirmPassword: [''],
    })
  }


  ngOnInit() {


    sessionStorage.setItem('role', '');


    this.loginForm = this.formBuilder.group({
      Email: ['', Validators.required],
      Password: ['', Validators.required],
    });
    
  }

  onSubmit() {
    
  }

  login() {
    console.log('LOGIN CLICKED');
  
    this.Customer = new CustomerDTO();
    const formData = this.loginForm.value;
    console.log('FORM DATA:', formData);
    this.Customer.Email = formData.Email;
    this.Customer.PasswordHash = formData.Password;
    this.authervice.login(this.Customer).subscribe({
      next: (res) => {
        console.log('SUCCESS:', res.body.role);
        this.authervice.setAdmin(res.body.role);
        this.router.navigate(['/dashboard/default']);
      },
      error: (err) => {
        console.log('HTTP ERROR:', err);
        console.log('STATUS:', err.status);
        console.log('BODY:', err.error);
      }
    });
  }
}
